import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {}
export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'multicheckbox-read' | Type<MultiCheckboxReadType>;
}
@Component({
  selector: 'multicheckbox-read-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  template: `
  <div>
    <ng-container *ngFor="let item of getOptionValues(); let i = index">
        <p class="mt-0.5">{{item}}</p>
   </ng-container>
  </div>

  `,
  imports:[NgFor]
})
export class MultiCheckboxReadType extends FieldType<FieldTypeConfig<InputProps>> {



    getOptionValues(): string[]{
        const values = this.formControl.value
        const options = this.props.options as Array<any>
        const results = [];

        if (options){
            for (let key in values){
                const vv = options.filter((x: any) => ( values[key] && x.value == key ))
                vv.length && results.push(vv[0].label)
            }
        }

        return results
    }



}
